export interface ClaimsFilterState {
  selectedServiceTypes: string[];
  selectedStatus: string[];
  selectedLocations: string[];
  selectedProviders: string[];
  selectedDate: string;
  customFromDate: string;
  customToDate: string;
  amountMin: string;
  amountMax: string;
}

export const initialClaimsFilterState: ClaimsFilterState = {
  selectedServiceTypes: [],
  selectedStatus: [],
  selectedLocations: [],
  selectedProviders: [],
  selectedDate: '',
  customFromDate: '',
  customToDate: '',
  amountMin: '',
  amountMax: '',
};
